import React, { useRef } from "react";
import { Typography, Avatar, Rating } from "@material-tailwind/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Testimonials() {
  const slider = useRef<Slider | null>(null);

  const next = () => {
    (slider.current as any)?.slickNext();
  };

  const previous = () => {
    (slider.current as any)?.slickPrev();
  };

  var testimonial = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      style={{ backgroundImage: `url("./images/bg-2.png")` }}
      className="bg-cover bg-no-repeat pt-2 "
    >
      <div className="container mx-auto my-16 relative items-center justify-center py-12">
        <h4 className="text-center text-xl text-[#037897] ">
          Témoignages
        </h4>
        <h2 className="text-center font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide mt-2	mb-6 ">
          Ce Que Nos Clients Disent        </h2>

        <Slider
          ref={(c) => (slider.current = c || null)}
          {...testimonial}
          className="p-6"
        >
          <div className="px-8 text-center">
            <Avatar
              src="./images/itestimonial.png"
              alt="image"
              size="sm"
              className="m-auto mt-6  max-h-32  bg-white"
            />
            <Typography variant="h6" className="mt-4">
              V. L., FRANCE
            </Typography>
            {/* <Typography className="mb-4 text-[#748B96] text-sm font-medium">
              VP of facebook
            </Typography> */}
            <Rating value={5} className="text-[#F5A623] mt-3 mb-6" readonly />
            <div className="relative md:w-[60%] m-auto pb-20">
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute -top-28 left-0 md:-left-20 "
              >
                <path
                  d="M5.7878 100.426H40.9773C44.1722 100.426 46.7651 97.8249 46.7651 94.6203V59.3227C46.7651 56.1181 44.1722 53.5172 40.9773 53.5172H24.135C24.3549 44.2748 26.4964 36.8786 30.5478 31.3169C33.7426 26.928 38.5812 23.2937 45.0519 20.4258C48.0268 19.1137 49.3117 15.584 47.9226 12.6348L43.7554 3.81039C42.4127 0.977303 39.0905 -0.265083 36.2198 0.977295C28.5568 4.29805 22.0861 8.50125 16.8077 13.6101C10.3717 19.8452 5.96144 26.8815 3.57689 34.7306C1.19233 42.5796 4.95911e-05 53.285 4.95911e-05 66.8699V94.6203C4.95911e-05 97.8249 2.59296 100.426 5.7878 100.426Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M100.591 1.00054C93.0207 4.30968 86.5847 8.51288 81.2715 13.6101C74.7777 19.8452 70.3442 26.8583 67.9597 34.6493C65.5751 42.4403 64.3829 53.1805 64.3829 66.8699V94.6203C64.3829 97.8249 66.9758 100.426 70.1706 100.426H105.36C108.555 100.426 111.148 97.8249 111.148 94.6203V59.3227C111.148 56.1181 108.555 53.5172 105.36 53.5172H88.5178C88.7377 44.2748 90.8792 36.8786 94.9306 31.3169C98.1254 26.928 102.964 23.2937 109.435 20.4258C112.41 19.1137 113.694 15.584 112.305 12.6348L108.15 3.83363C106.807 1.00053 103.462 -0.253448 100.591 1.00054Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>

              <Typography
                variant="h2"
                color="blue-gray"
                className="mb-6  text-center font-medium  text-[#546E7A] leading-7 text-lg"
              >
                &quot;Je ne sais pas ce que nous serions devenues, ma soeur et moi, si nous n'avions pu bénéficier de son expérience et de ses soins.&quot;
              </Typography>
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute bottom-2 right-0 md:-right-20"
              >
                <path
                  d="M107.077 0.425781H71.8879C68.6931 0.425781 66.1002 3.02665 66.1002 6.2313V41.5288C66.1002 44.7335 68.6931 47.3344 71.8879 47.3344H88.7303C88.5103 56.5767 86.3689 63.973 82.3174 69.5346C79.1226 73.9236 74.284 77.5579 67.8133 80.4258C64.8384 81.7378 63.5536 85.2676 64.9426 88.2168L69.1098 97.0412C70.4526 99.8743 73.7747 101.117 76.6454 99.8743C84.3084 96.5535 90.7791 92.3503 96.0576 87.2415C102.494 81.0063 106.904 73.9701 109.288 66.121C111.673 58.2719 112.865 47.5666 112.865 33.9817V6.2313C112.865 3.02665 110.272 0.425781 107.077 0.425781Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M12.2742 99.851C19.8446 96.5419 26.2806 92.3387 31.5937 87.2414C38.0876 81.0063 42.521 73.9933 44.9055 66.2023C47.2901 58.4113 48.4824 47.6711 48.4824 33.9817V6.2313C48.4824 3.02665 45.8895 0.425781 42.6946 0.425781H7.5051C4.31026 0.425781 1.71735 3.02665 1.71735 6.2313V41.5288C1.71735 44.7335 4.31026 47.3343 7.5051 47.3343H24.3475C24.1275 56.5767 21.986 63.9729 17.9346 69.5346C14.7398 73.9236 9.90123 77.5578 3.43053 80.4258C0.455623 81.7378 -0.829257 85.2676 0.559803 88.2168L4.71541 97.0179C6.05816 99.851 9.40348 101.105 12.2742 99.851Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>
            </div>
          </div>

          <div className="px-8 text-center">
            <Avatar
              src="./images/testi.png"
              alt="image"
              size="sm"
              className="m-auto mt-6  max-h-32  bg-white"
            />
            <Typography variant="h6" className="mt-4">
              C. M, SUISSE
            </Typography>
            {/* <Typography className="mb-4 text-[#748B96] text-sm font-medium">
              VP of facebook
            </Typography> */}
            <Rating value={5} className="text-[#F5A623] mt-3 mb-6" readonly />
            <div className="relative md:w-[60%] m-auto pb-20">
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute -top-28 left-0 md:-left-20 "
              >
                <path
                  d="M5.7878 100.426H40.9773C44.1722 100.426 46.7651 97.8249 46.7651 94.6203V59.3227C46.7651 56.1181 44.1722 53.5172 40.9773 53.5172H24.135C24.3549 44.2748 26.4964 36.8786 30.5478 31.3169C33.7426 26.928 38.5812 23.2937 45.0519 20.4258C48.0268 19.1137 49.3117 15.584 47.9226 12.6348L43.7554 3.81039C42.4127 0.977303 39.0905 -0.265083 36.2198 0.977295C28.5568 4.29805 22.0861 8.50125 16.8077 13.6101C10.3717 19.8452 5.96144 26.8815 3.57689 34.7306C1.19233 42.5796 4.95911e-05 53.285 4.95911e-05 66.8699V94.6203C4.95911e-05 97.8249 2.59296 100.426 5.7878 100.426Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M100.591 1.00054C93.0207 4.30968 86.5847 8.51288 81.2715 13.6101C74.7777 19.8452 70.3442 26.8583 67.9597 34.6493C65.5751 42.4403 64.3829 53.1805 64.3829 66.8699V94.6203C64.3829 97.8249 66.9758 100.426 70.1706 100.426H105.36C108.555 100.426 111.148 97.8249 111.148 94.6203V59.3227C111.148 56.1181 108.555 53.5172 105.36 53.5172H88.5178C88.7377 44.2748 90.8792 36.8786 94.9306 31.3169C98.1254 26.928 102.964 23.2937 109.435 20.4258C112.41 19.1137 113.694 15.584 112.305 12.6348L108.15 3.83363C106.807 1.00053 103.462 -0.253448 100.591 1.00054Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>

              <Typography
                variant="h2"
                color="blue-gray"
                className="mb-6  text-center font-medium  text-[#546E7A] leading-7 text-lg"
              >
                &quot;Cette thérapeute d'exception a fait un travail remarquable sur moi, elle ne comptait pas son temps, son dévouement était total et sa disponibilité sans faille. Madame Evelyne Kinder m'a redonné l'espoir, elle m'a remise debout, elle m'a soignée comme aucun autre médecin n'a su le faire !&quot;
              </Typography>
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute bottom-2 right-0 md:-right-20"
              >
                <path
                  d="M107.077 0.425781H71.8879C68.6931 0.425781 66.1002 3.02665 66.1002 6.2313V41.5288C66.1002 44.7335 68.6931 47.3344 71.8879 47.3344H88.7303C88.5103 56.5767 86.3689 63.973 82.3174 69.5346C79.1226 73.9236 74.284 77.5579 67.8133 80.4258C64.8384 81.7378 63.5536 85.2676 64.9426 88.2168L69.1098 97.0412C70.4526 99.8743 73.7747 101.117 76.6454 99.8743C84.3084 96.5535 90.7791 92.3503 96.0576 87.2415C102.494 81.0063 106.904 73.9701 109.288 66.121C111.673 58.2719 112.865 47.5666 112.865 33.9817V6.2313C112.865 3.02665 110.272 0.425781 107.077 0.425781Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M12.2742 99.851C19.8446 96.5419 26.2806 92.3387 31.5937 87.2414C38.0876 81.0063 42.521 73.9933 44.9055 66.2023C47.2901 58.4113 48.4824 47.6711 48.4824 33.9817V6.2313C48.4824 3.02665 45.8895 0.425781 42.6946 0.425781H7.5051C4.31026 0.425781 1.71735 3.02665 1.71735 6.2313V41.5288C1.71735 44.7335 4.31026 47.3343 7.5051 47.3343H24.3475C24.1275 56.5767 21.986 63.9729 17.9346 69.5346C14.7398 73.9236 9.90123 77.5578 3.43053 80.4258C0.455623 81.7378 -0.829257 85.2676 0.559803 88.2168L4.71541 97.0179C6.05816 99.851 9.40348 101.105 12.2742 99.851Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>
            </div>
          </div>

          <div className="px-8 text-center">
            <Avatar
              src="./images/itestimonial.png"
              alt="image"
              size="sm"
              className="m-auto mt-6  max-h-32  bg-white"
            />
            <Typography variant="h6" className="mt-4">
              L.B, SUISSE
            </Typography>
            {/* <Typography className="mb-4 text-[#748B96] text-sm font-medium">
              VP of facebook
            </Typography> */}
            <Rating value={5} className="text-[#F5A623] mt-3 mb-6" readonly />
            <div className="relative md:w-[60%] m-auto pb-20">
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute -top-28 left-0 md:-left-20 "
              >
                <path
                  d="M5.7878 100.426H40.9773C44.1722 100.426 46.7651 97.8249 46.7651 94.6203V59.3227C46.7651 56.1181 44.1722 53.5172 40.9773 53.5172H24.135C24.3549 44.2748 26.4964 36.8786 30.5478 31.3169C33.7426 26.928 38.5812 23.2937 45.0519 20.4258C48.0268 19.1137 49.3117 15.584 47.9226 12.6348L43.7554 3.81039C42.4127 0.977303 39.0905 -0.265083 36.2198 0.977295C28.5568 4.29805 22.0861 8.50125 16.8077 13.6101C10.3717 19.8452 5.96144 26.8815 3.57689 34.7306C1.19233 42.5796 4.95911e-05 53.285 4.95911e-05 66.8699V94.6203C4.95911e-05 97.8249 2.59296 100.426 5.7878 100.426Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M100.591 1.00054C93.0207 4.30968 86.5847 8.51288 81.2715 13.6101C74.7777 19.8452 70.3442 26.8583 67.9597 34.6493C65.5751 42.4403 64.3829 53.1805 64.3829 66.8699V94.6203C64.3829 97.8249 66.9758 100.426 70.1706 100.426H105.36C108.555 100.426 111.148 97.8249 111.148 94.6203V59.3227C111.148 56.1181 108.555 53.5172 105.36 53.5172H88.5178C88.7377 44.2748 90.8792 36.8786 94.9306 31.3169C98.1254 26.928 102.964 23.2937 109.435 20.4258C112.41 19.1137 113.694 15.584 112.305 12.6348L108.15 3.83363C106.807 1.00053 103.462 -0.253448 100.591 1.00054Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>

              <Typography
                variant="h2"
                color="blue-gray"
                className="mb-6  text-center font-medium  text-[#546E7A] leading-7 text-lg"
              >
                &quot;Madame Kinder m'a suivie pour douleurs diverses et infections. J'avais l'impression de mourir. Médicalement, personne ne pouvait m'éclairer sur le pourquoi j'allais si mal. Merci à Madame Kinder qui m'a aidée patiemment. S'il y a bien quelqu'un qui aime ses patients et qui travaille avec compétence, c'est bien elle. Depuis ses traitements manuels, j'ai beaucoup plus d'énergie, assume mieux les difficultés. J'avais aussi de graves problèmes respiratoires. J'ai énormément progressé à ce niveau. Ma mobilité est bien meilleure. &quot;
              </Typography>
              <svg
                width="113"
                height="101"
                viewBox="0 0 113 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[25%] md:w-auto absolute bottom-2 right-0 md:-right-20"
              >
                <path
                  d="M107.077 0.425781H71.8879C68.6931 0.425781 66.1002 3.02665 66.1002 6.2313V41.5288C66.1002 44.7335 68.6931 47.3344 71.8879 47.3344H88.7303C88.5103 56.5767 86.3689 63.973 82.3174 69.5346C79.1226 73.9236 74.284 77.5579 67.8133 80.4258C64.8384 81.7378 63.5536 85.2676 64.9426 88.2168L69.1098 97.0412C70.4526 99.8743 73.7747 101.117 76.6454 99.8743C84.3084 96.5535 90.7791 92.3503 96.0576 87.2415C102.494 81.0063 106.904 73.9701 109.288 66.121C111.673 58.2719 112.865 47.5666 112.865 33.9817V6.2313C112.865 3.02665 110.272 0.425781 107.077 0.425781Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
                <path
                  d="M12.2742 99.851C19.8446 96.5419 26.2806 92.3387 31.5937 87.2414C38.0876 81.0063 42.521 73.9933 44.9055 66.2023C47.2901 58.4113 48.4824 47.6711 48.4824 33.9817V6.2313C48.4824 3.02665 45.8895 0.425781 42.6946 0.425781H7.5051C4.31026 0.425781 1.71735 3.02665 1.71735 6.2313V41.5288C1.71735 44.7335 4.31026 47.3343 7.5051 47.3343H24.3475C24.1275 56.5767 21.986 63.9729 17.9346 69.5346C14.7398 73.9236 9.90123 77.5578 3.43053 80.4258C0.455623 81.7378 -0.829257 85.2676 0.559803 88.2168L4.71541 97.0179C6.05816 99.851 9.40348 101.105 12.2742 99.851Z"
                  fill="#858D96"
                  fill-opacity="0.08"
                />
              </svg>
            </div>
          </div>
        </Slider>
        {/* <div className="absolute hidden md:block top-[20%] right-[5%]">
          <img src="./images/t-1.png" className="transition-transform duration-300 hover:scale-95"/>
        </div>
        <div className="absolute hidden md:block top-[30%] left -[10%]">
          <img src="./images/t-2.png" className="transition-transform duration-300 hover:scale-95"/>
        </div>
        <div className="absolute hidden md:block top-[40%] right-[30%]">
          <img src="./images/t-3.png" className="transition-transform duration-300 hover:scale-95"/>
        </div>
        <div className="absolute hidden md:block top-[25%] left-[30%]">
          <img src="./images/t-4.png"  className="transition-transform duration-300 hover:scale-95"/>
        </div> */}
        <button
          onClick={previous}
          className="absolute top-[50%] left-5 md:left-0 rotate-180 transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:scale-110"
        >
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[60%] md:w-full"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27 51.8164C40.8054 51.8164 52 40.6245 52 26.8164C52 13.011 40.8054 1.81641 27 1.81641C13.1946 1.81641 2 13.011 2 26.8164C2 40.6245 13.1946 51.8164 27 51.8164Z"
              stroke="#037897"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.1017 36.1982L32.5234 26.8172L23.1017 17.4361"
              stroke="#037897"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button onClick={next} className="absolute top-[50%] -right-8 md:right-0 transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:scale-110">
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[60%] md:w-full"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27 51.8164C40.8054 51.8164 52 40.6245 52 26.8164C52 13.011 40.8054 1.81641 27 1.81641C13.1946 1.81641 2 13.011 2 26.8164C2 40.6245 13.1946 51.8164 27 51.8164Z"
              stroke="#037897"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.1017 36.1982L32.5234 26.8172L23.1017 17.4361"
              stroke="#037897"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
